/* eslint-disable camelcase */
import React from 'react';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Modal,
  Fade,
  Backdrop,
  TextField,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core';

import PropTypes from 'prop-types';

import { Formik } from 'formik';
import * as yup from 'yup';

import { inviteUser } from '../store/actions/admin';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 18,
    margin: 0,
    color: '#1e3f9e',
    marginBottom: 25,
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    padding: '2rem',
    paddingTop: '1rem',
    minWidth: 550,
    maxWidth: '700px',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 4,
    boxShadow: theme.shadows[5],
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  buttonRow: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '2rem',
    width: '100%',
    justifyContent: 'space-around',
  },
  button: {
    width: '30%',
    padding: '0.6rem',
    color: 'white',
    backgroundColor: '#00d1b2',
    '&:hover': {
      backgroundColor: '#00bca0',
    },
  },
  form: {
    margin: '1rem',
    width: '100%',
    display: 'flex',
    flexFlow: 'row wrap',
  },
  field: {
    width: '100%',
  },
  error: {
    color: 'red',
  },
  nameFieldContainer: {
    width: '40%',
    marginLeft: '5%',
    marginRight: '5%',
    marginTop: '0.5rem',
    marginBottom: '0.5rem',
    flexFlow: 'column',
  },
}));

const InviteModal = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
  };

  const submitHandler = (values) => {
    dispatch(inviteUser({ ...values, email: values.email.toLowerCase() }));
    setOpen(false);
    toast.success('User successfully invited.', {
      position: 'bottom-left',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      theme: 'colored',
    });
  };

  const validationSchema = yup.object({
    email: yup.string("Enter User's Email").email('Enter a valid email').required('*Required'),
  });

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
    >
      <Fade in={open}>
        <div className={classes.paper}>
          <h2 className={classes.title}>Invite New User</h2>
          <Formik
            initialValues={{ email: '', role: 'HCP' }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setTimeout(() => {
                submitHandler(values);
                setSubmitting(false);
              }, 400);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              /* and other goodies */
            }) => {
              return (
                <form className={classes.form} onSubmit={handleSubmit}>
                  <div className={classes.nameFieldContainer}>
                    <TextField
                      className={classes.field}
                      label="Email"
                      placeholder="Enter User's Email"
                      variant="outlined"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                    />
                    <p className={classes.error}>{errors.email && touched.email && errors.email}</p>
                  </div>
                  <div className={classes.radioContainer}>
                    <FormControl>
                      <FormLabel id="radio-buttons">Role</FormLabel>
                      <RadioGroup
                        aria-labelledby="radio-buttons"
                        defaultValue="HCP"
                        name="radio-buttons-group"
                        onChange={handleChange}
                      >
                        <FormControlLabel value="Supervisor" name="role" control={<Radio />} label="Supervisor" />
                        <FormControlLabel value="HCP" name="role" control={<Radio />} label="Provider" />
                      </RadioGroup>
                    </FormControl>
                  </div>
                  <div className={classes.buttonRow}>
                    <Button
                      className={classes.button}
                      size="small"
                      variant="contained"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      Submit
                    </Button>
                    <Button className={classes.button} size="small" variant="contained" onClick={handleClose}>
                      Cancel
                    </Button>
                  </div>
                </form>
              );
            }}
          </Formik>
        </div>
      </Fade>
    </Modal>
  );
};

InviteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export default InviteModal;
